import { useEffect,useState } from 'react';

export const useScreen = () => {
  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 600;
  const isDesktop = width > 600;
  const isMobileDialog = width <= 720;

  return { isMobile, isDesktop, isMobileDialog };
};
